
import React from 'react';
import classNames from 'classnames';

const ButtonField = ({ callDetailsValue, val, type, classname, title, className, onclick }) => {
  const buttonActive = callDetailsValue == val ?
  classNames({
    'btn': true,
    'btn-block': true,
    'btn-primary': true,
  }):
  classNames({
    'btn btn-block': true,
    'btn-secondary': val === "go",
  });
  return (
    <div >
      <div >
        <button className={buttonActive } value={val} type={type} onClick={() => onclick(val)}>
          {title}
        </button>
      </div>
    </div>
  );
};
export default ButtonField;



// WEBPACK FOOTER //
// ./src/lib/forms/Button.js